import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import BonusesImpl from './bonuses.js';
import { noop } from 'mojito/utils';

/**
 * Component that presents tabbed pane with active bonuses, in-progress bonuses and bonus history.
 *
 * @class Bonuses
 * @name module
 * @memberof Mojito.Modules.Bonuses
 */

/**
 * Bonuses prop types.
 *
 * @property {Mojito.Services.Bonus.types.BONUS_FILTER} [defaultTab] - Defines default tab. Component could then change tab based on data.
 * @property {Mojito.Modules.Bonuses.onSelectedTabChange} [onSelectedTabChange = () => {}] - Callback for handling click on the tab.
 *
 * @memberof Mojito.Modules.Bonuses
 */
const propTypes = {
    defaultTab: PropTypes.oneOf(['ACTIVE', 'IN_PROGRESS', 'HISTORIC']),
    onSelectedTabChange: PropTypes.func,
};

const defaultPropTypes = {
    onSelectedTabChange: noop,
};

export default MojitoCore.Presentation.UIView('Bonuses', BonusesImpl, propTypes, defaultPropTypes);
